import { Component, OnInit } from '@angular/core';
import { landingServices } from 'src/app/landing/Services/landing.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-second',
  templateUrl: './footer-second.component.html',
  styleUrls: ['./footer-second.component.css']
})
export class FooterSecondComponent implements OnInit{
  Year: number = new Date().getFullYear();
  IsLogin!: boolean;
  copyright = '';
  constructor(private landingServices: landingServices) {
    this.copyright = environment.footerCopyrightReserved;
  }

  async ngOnInit() 
  {
    this.IsLogin =await this.landingServices.showFooter();
  }
}
